import { render, staticRenderFns } from "./CardForm.vue?vue&type=template&id=eb56f428&"
import script from "./CardForm.vue?vue&type=script&lang=ts&"
export * from "./CardForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports